import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'index',
    component: () => import(/* webpackChunkName: "home" */ '@/pages/index/index.vue'),
    meta: {
      keepAlive: true,
    },
  },
  {
    path: '/ranking',
    name: 'ranking',
    component: () => import(/* webpackChunkName: "home" */ '@/pages/ranking/index.vue')
  },
  {
    path: '/mine',
    name: 'mine',
    component: () => import(/* webpackChunkName: "home" */ '@/pages/mine/index.vue')
  },
  {
    path: '/bookDetail/:id',
    name: 'detail',
    component: () => import(/* webpackChunkName: "home" */ '@/pages/bookdetail/index.vue')
  },
  {
    path: '/about',
    name: 'about',
    component: () => import(/* webpackChunkName: "home" */ '@/pages/about/index.vue')
  },
  
  {
    path: '/privacy',
    name: 'privacy',
    component: () => import(/* webpackChunkName: "home" */ '@/pages/privacy/index.vue')
  },
  {
    path: '/service',
    name: 'service',
    component: () => import(/* webpackChunkName: "home" */ '@/pages/service/index.vue')
  },
  {
    path: '/contact',
    name: 'contact',
    component: () => import(/* webpackChunkName: "home" */ '@/pages/contact/index.vue')
  },
  {
    path: '/disclaimer',
    name: 'disclaimer',
    component: () => import(/* webpackChunkName: "home" */ '@/pages/disclaimer/index.vue')
  },
  {
    path: '/dmca',
    name: 'dmca',
    component: () => import(/* webpackChunkName: "home" */ '@/pages/dmca/index.vue')
  },
  {
    path: '/reader/:id/:chapter',
    name: 'reader',
    component: () => import(/* webpackChunkName: "home" */ '@/pages/bookReader/index.vue')
  },
  {
    path: '/reader-t/:id/:chapter',
    name: 'reader-taboola',
    component: () => import(/* webpackChunkName: "home" */ '@/pages/bookReader/taboola.vue')
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
        return savedPosition
    }else{
      return {
        x: 0,
        y: 0
      }
    }
  }
})

export default router
